import { Transform } from 'class-transformer';
import { get } from 'lodash-es';

export function Sort(key = 'id') {
  return Transform(({ value }) => {
    if (!value || !key || !Array.isArray(value) || !value.length || value.length < 2) return value;

    return value.sort((a, b) => {
      const valueA = get(a, key);
      const valueB = get(b, key);

      if (valueA < valueB) {
        return -1;
      }

      if (valueA > valueB) {
        return 1;
      }

      return 0;
    });
  });
}
